export default {"src":"/_next/static/media/shieldWithInfo_64.fcf432a6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};